import React from "react";
import { Link } from "react-router-dom";
import { CANT_FIND_PAGE } from "../../configurations/MessageConstants";

const PageNotFound = () => {
  return (
    <div className="d-flex justify-content-center h-100 page-not-found">
      <div className="align-self-center text-center">
        <h2 className="trns-text">404 Error</h2>
        <h3>{CANT_FIND_PAGE}</h3>
        <Link to="/map" className="btn btn-secondary mt-5">
          Go to Homepage
        </Link>
      </div>
    </div>
  );
};

export default PageNotFound;
